// extracted by mini-css-extract-plugin
export default {"link":"Home_link__GMkwB"};